import React, { useMemo } from "react";
import Navbar from "app/components/Navbar";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import TabButton from "app/components/Button/TabButton";
import { useHistory, useParams } from "react-router-dom";

interface IGroupSettingsLayout {
  children: React.ReactNode;
}

const GroupSettingsLayout = ({ children }: IGroupSettingsLayout) => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const history = useHistory();

  const tabs = useMemo(() => {
    return [
      { label: t("General"), path: `/groups/${id}/settings/general` },
      { label: t("Permissions"), path: `/groups/${id}/settings/permissions` },
    ];
  }, [id]);

  const route = (id: string) => {
    history.push(id);
  };

  const onRouteClick = (path: string) => {
    route(path);
  };

  const onGoBack = () => {
    history.push(`/groups/${id}`);
  };

  return (
    <div>
      <Navbar
        onBackClick={onGoBack}
        label={t("Group Settings")}
        className={styles.navbar}
        hasNotifications={false}
        hasSearch={false}
      />
      <div className={styles.container}>
        <div className={styles.tabs_wrapper}>
          {tabs.map((tab) => {
            return (
              <TabButton
                key={tab.label}
                label={tab.label}
                isActive={location.pathname.includes(tab.path)}
                onClick={() => {
                  onRouteClick(tab.path);
                }}
              />
            );
          })}
        </div>
        {children}
      </div>
    </div>
  );
};

export default GroupSettingsLayout;
